import React, { useState, useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import Sidebar from './Sidebar';
import 'bootstrap/dist/css/bootstrap.min.css';

// --- LÓGICA WHITE LABEL ---
const CLIENT_NAME = process.env.REACT_APP_CLIENT_NAME || "Dashboard";

const Layout = ({ children, activeKey }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);  // mobile overlay
  const [collapsed, setCollapsed] = useState(() => {
    const saved = localStorage.getItem('sidebar-collapsed');
    return saved === 'true';
  });

  useEffect(() => {
    localStorage.setItem('sidebar-collapsed', collapsed);
  }, [collapsed]);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 768) {
        setSidebarOpen(false); // mobile fechado por padrão
      }
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const toggleSidebar = () => {
    if (window.innerWidth <= 768) {
      setSidebarOpen(v => !v);      // mobile: overlay
    } else {
      setCollapsed(v => !v);        // desktop: colapsa largura
    }
  };

  const closeSidebar = () => setSidebarOpen(false);

  return (
    <Container fluid className="app p-0">
      {/* Botão de menu visível no mobile 
        REFATORADO: Removemos o bg-dark e usamos as variáveis CSS do cliente
      */}
      <div 
        className="d-md-none p-2 d-flex align-items-center"
        style={{ backgroundColor: 'var(--brand-secondary)', color: 'var(--brand-text-on-dark)' }}
      >
        <button 
          className="btn" 
          onClick={toggleSidebar}
          style={{ color: 'var(--brand-text-on-dark)', border: 'none', background: 'transparent' }}
        >
          <i className="bi bi-list fs-4"></i>
        </button>
        <span className="ms-2 fw-bold text-uppercase" style={{ letterSpacing: '1px' }}>
          {CLIENT_NAME}
        </span>
      </div>

      <Row className="g-0">
        {/* Desktop: coluna fixa do grid */}
        <Col
          xs="auto"
          className="d-none d-md-block p-0"
        >
          <div className={`sidebar ${collapsed ? 'collapsed' : 'expanded'}`}>
            <Sidebar
              activeKey={activeKey}
              toggleSidebar={toggleSidebar}
              sidebarOpen={sidebarOpen}
              collapsed={collapsed}
            />
          </div>
        </Col>

        {/* Mobile: overlay fora do grid */}
        <div className={`sidebar d-md-none ${sidebarOpen ? 'show' : ''}`}>
          <Sidebar
            activeKey={activeKey}
            toggleSidebar={toggleSidebar}
            sidebarOpen={sidebarOpen}
            collapsed={false}
          />
        </div>

        <Col className="main-content" style={{ minWidth: 0 }}>
          {children}
        </Col>
      </Row>

      {sidebarOpen && <div className="sidebar-overlay d-md-none" onClick={closeSidebar} />}
    </Container>
  );
};

export default Layout;